// @flow
import React, { type Node } from 'react';

type Props = {
  children?: Node,
  label: Node,
  labelClassName?: string,
  style?: Object,
};

export default function LabeledField({
  children,
  label,
  labelClassName,
  style,
}: Props) {
  return (
    <div className="field is-horizontal" style={style}>
      <div className={`field-label is-normal ${labelClassName || ''}`}>
        <label className="label">{label}</label>
      </div>
      <div className="field-body">
        <div className="field">
          <div className="control">{children}</div>
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/view/Forms/LabeledField.js